import React from 'react';
import './isi.scss';
import IsiListItem from './IsiListItem';
import IsiList from './IsiList';

function IsiLists({ items, wrap, index, padding }) {
  return (
    <ul
      className={
        wrap
          ? 'isi__body__list--wrap__ul'
          : padding
          ? `isi__body__ul isi__body__ul--${padding}`
          : 'isi__body__ul'
      }
    >
      {items.map((item, i) => {
        return item.map((listItem, i) => {
          return (
            <div
              key={`list-${index}-${i}`}
              className={padding === 'bottom' && 'isi__body__ul--bottom'}
            >
              <IsiListItem el={listItem} key={`listItem-${index}-${i}`} />
              {listItem.subList &&
                (listItem.subList.length > 1 ? (
                  <div className="isi__body__list isi__body__list--wrap">
                    {listItem.subList.map((sub, i) => {
                      return (
                        <IsiList item={sub} wrap={true} key={`sublist-${index}-${i}`} sub={true} />
                      );
                    })}
                  </div>
                ) : (
                  listItem.subList.map((sub, i) => {
                    return <IsiList item={sub} key={`sublist-${index}-${i}`} sub={true} />;
                  })
                ))}
            </div>
          );
        });
      })}
    </ul>
  );
}

export default IsiLists;
